<template>
  <div class="wj-navbar">
    <el-menu
      router
      active-text-color="#FF552E"
      menu-trigger="click"
      :default-active="activeIndex"
      mode="horizontal"
    >
      <div class="wj-logo pull-left">
        <img src="../assets/logo2020.svg" @click="handleHome" />
      </div>
      <el-menu-item index="/home/mine">
        <template>
          <span>我的问卷</span>
          <div class="bottom-line"></div>
        </template>
      </el-menu-item>
      <el-menu-item index="/home/help/articleList">
        <template>
          <span>用户帮助</span>
          <div class="bottom-line"></div>
        </template>
        <span class="new-circle" v-if="!attention"></span>
      </el-menu-item>
      <el-menu-item index="/home/taskCenter">
        <template>
          <span>任务中心</span>
          <div class="bottom-line"></div>
        </template>
      </el-menu-item>
      <el-menu-item
        index="/home/template"
        v-if="role.indexOf('manager') > -1 || role.indexOf('admin') > -1"
      >
        <template>
          <span>模版管理</span>
          <div class="bottom-line"></div>
        </template>
      </el-menu-item>
      <!-- <el-submenu class="wj-help" index="/">
        <template slot="title">
          <svg class="icon svg-icon emil-icon" aria-hidden="true">
            <use xlink:href="#icon-yijianfankui" />
          </svg>
          <span>意见建议</span>
        </template>
      </el-submenu>-->
      <el-submenu class="user-info" index="/">
        <template slot="title">
          <img class="headpic" :src="headPic" alt />
          <span>{{ user }}</span>
        </template>
        <el-menu-item index="/">
          <a style="color: #333; display: block" href="javascript:;" @click="handleLogout">退出</a>
        </el-menu-item>
      </el-submenu>
      <a href="javascript:;" class="wj-help" @click="handleFeedBack">
        <svg class="icon svg-icon emil-icon" aria-hidden="true">
          <use xlink:href="#icon-yijianfankui" />
        </svg>
        <span>意见建议</span>
      </a>
      <a href="javascript:;" class="wj-notice" @click="showDialog">
        <span>
          <i class="el-icon-bell"></i>重要通知
        </span>
      </a>
    </el-menu>
    <div class="header-gray"></div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "Navbar",
  watch: {
    "$route.path": function () {
      this.changeRoute();
    },
  },
  data() {
    return {
      activeIndex: this.$route.path,
    };
  },
  props: ["user", "headPic"],
  computed: {
    ...mapGetters(["attention", "role"]),
  },
  methods: {
    showDialog() {
      this.$myDialog.show();
    },
    changeRoute() {
      let path = this.$route.path;
      if (path.indexOf("/home/help") > -1) {
        path = "/home/help/articleList";
      } else if (
        path.indexOf("/home/mine") > -1 ||
        path.indexOf("/home/put") > -1 ||
        path.indexOf("/home/edit") > -1 ||
        path.indexOf("/home/folder") > -1
      ) {
        path = "/home/mine";
      } else if (path.indexOf("/home/template") > -1) {
        path = "/home/template";
      } else if (path.indexOf("/home/taskCenter") > -1) {
        path = "/home/taskCenter";
      }
      this.activeIndex = path;
    },
    handleHome() {
      this.$router.push({
        path: "/home/mine",
        query: {},
      });
    },
    handleFeedBack() {
      window.open("https://survey.58.com/?id=1003931&hash=qs98");
    },
    handleLogout() {
      var sdk_pc = window.SDK_PC();
      sdk_pc.logout(
        {
          source: "58-wenjuan-pc",
        },
        function () {
          window.location.replace(`${window.location.origin}/#/login`);
        }
      );
    },
  },
};
</script>

<style lang="scss">
.wj-navbar {
  height: 78px;
  background: #fff;
  .el-menu {
    padding-left: 45px;
    .el-submenu__title i {
      color: #666;
    }
    .el-menu-item {
      border-bottom: 0 !important;
    }
    .el-menu-item.is-active {
      span {
        background-image: -webkit-linear-gradient(
          bottom,
          #ff8100,
          #ff6200,
          #ff6200
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .bottom-line {
        background-image: linear-gradient(
          270deg,
          #ff8100 0%,
          #ff6200 100%,
          #ff6200 100%
        );
        width: 22px;
        height: 4px;
        border-radius: 2px;
        border-radius: 2px;
        position: absolute;
        bottom: 0;
        left: 48px;
        display: inline-block;
      }
    }
    .user-info {
      float: right;
      margin-right: 35px;
      .headpic {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 1px solid #ccc;
      }
      span {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #666666;
        letter-spacing: 0;
        text-align: right;
      }
    }
  }
  .el-menu--horizontal {
    border: none;
    .el-menu-item {
      font-size: 16px;
      padding: 0;
      color: #333;
      width: 120px;
      text-align: center;
      font-family: PingFangSC-Medium;
      font-weight: bold;
    }
  }
  .wj-logo {
    height: 60px;
    width: 118px;
    margin-right: 65px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      transform: scale(0.9);
    }
  }
  .new-circle {
    background-color: red;
    width: 10px;
    height: 10px;
    display: inline-block;
    border-radius: 50%;
    position: relative;
    top: -10px;
    left: -5px;
  }
  .wj-notice {
    float: right;
    height: 60px;
    width: 90px;
    overflow: hidden;
    line-height: 60px;
    margin-right: 15px;
    cursor: pointer;
    span {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #666666;
      .el-icon-bell {
        font-size: 18px;
        margin-right: 3px;
        top: 1px;
        position: relative;
        font-weight: bold;
        color: #9e9e9e;
      }
      &:hover {
        color: #ff552d;
        .el-icon-bell{
          color: #ff552d;
        }
      }
    }
  }
  .wj-help {
    float: right;
    height: 60px;
    width: 90px;
    overflow: hidden;
    line-height: 60px;
    cursor: pointer;
    .emil-icon {
      width: 18px;
      height: 18px;
      position: relative;
      top: 4px;
    }
    span {
      display: inline-block;
      height: 60px;
      line-height: 60px;
      position: absolute;
      width: 60px;
      margin-left: 4px;
    }
  }
  .header-gray {
    height: 16px;
    opacity: 0.02;
    background-image: linear-gradient(
      180deg,
      #000000 0%,
      rgba(0, 0, 0, 0) 100%
    );
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue